export const supportedLocales = [
  {
    iso2: 'AU',
    slug: 'au',
    hreflang: 'en-au',
    label: 'Australia',
    labelLong: 'Australia',
    emoji: '🇦🇺',
  },
  {
    iso2: 'GB',
    slug: 'gb',
    hreflang: 'en-gb',
    label: 'UK',
    labelLong: 'United Kingdom',
    emoji: '🇬🇧',
  },
  {
    iso2: 'US',
    slug: 'us',
    hreflang: 'en-us',
    label: 'United States',
    labelLong: 'United States',
    emoji: '🇺🇸',
  },
];

export const supportedIso2s = supportedLocales.map((l) => l.iso2);

export const supportedSlugs = supportedLocales.map((l) => l.slug);

export const defaultCountryIso2 = 'US';

const locale = [...supportedLocales, { hreflang: 'x-default' }];

/**
 * @param {String} slug
 * @returns {*}
 */
export const getLocaleForUrlSlug = (slug) => {
  if (!slug) return;
  const result = supportedLocales.find((el) => el.slug === slug);

  return result;
};

/**
 * @param {String} localeIso2
 * @returns {String}
 */
export const getSlugForLocale = (localeIso2) => {
  if (!localeIso2) return '';
  const result = supportedLocales.find((el) => el.iso2 === localeIso2);

  if (result) {
    return result.slug;
  }

  return '';
};

export default locale;
